import React, { FC } from 'react';

import { useParams } from 'react-router-dom';

import { GameCenterViewType } from './enums';
import Boxscore from './sections/boxscore/Boxscore';
import GameCenterLayout from './sections/gameCenterLayout/GameCenterLayout';
import Landing from './sections/landing/Landing';
import PlayByPlay from './sections/playByPlay/PlayByPlay';

const GameCenter: FC = () => {
    const params = useParams();
    const gameId = isNaN(Number(params.gameId)) ? undefined : Number(params.gameId);
    const view = params.view;

    let display = <Landing gameId={gameId} />;
    if (view === GameCenterViewType.BOXSCORE) {
        display = <Boxscore gameId={gameId} />;
    } else if (view === GameCenterViewType.PLAYBYPLAY) {
        display = <PlayByPlay gameId={gameId} />;
    }

    return <GameCenterLayout>{display}</GameCenterLayout>;
};

export { GameCenter as Component };
